import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

function Pricing() {
    const navigate = useNavigate();

    const AddToCart = (subsctiptionName, perCreditPrice, totalCredits, productDescription) => {

        let subscriptionCart = {
            SubscriptionName: subsctiptionName,
            PerCreditPrice: perCreditPrice,
            SubscriptionPrice: perCreditPrice * totalCredits,
            ProductDescription: productDescription,
            Quantity: 1
        }
        localStorage.setItem("SubscriptionCart", JSON.stringify([subscriptionCart]));

        navigate("/Checkout");
    }

    return (
        <>
            <div className="container-fluid px-5 py-2">
            <Header/>
            </div>
            
            <div className="container">
                <div className="pricing-header p-3 pb-md-4 mx-auto text-center">
                    <h1 className="display-4 fw-normal text-body-emphasis">Pricing</h1>
                    <p className="fs-5 text-body-secondary">At DecipherX, we offer flexible pricing to match your workflow—whether you’re running occasional audio CAPTCHA transcriptions or handling high-volume, automated tasks.
                        Choose from pay-as-you-go or monthly subscriptions to fit your usage needs.</p>
                </div>
                <main style={{ minHeight: "65vh" }}>
                    <div className="row row-cols-1 row-cols-md-3 mb-3 text-center">
                        <div className="col">
                            <div className="card mb-4 rounded-3 shadow-sm">
                                <div className="card-header py-3">
                                    <h4 className="my-0 fw-normal">Starter</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">₹0.24<small className="text-body-secondary fw-light">/audio</small></h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>150k audios included</li>
                                        <li>Only successfull transcriptions</li>
                                        <li>Max 15 sec per audio clip</li>
                                        <li>TAT - Instant (&lt; 5 seconds)</li>
                                        <li>Email support</li>
                                        <li className="text-success"> <strong>3 days money back guarantee</strong></li>
                                        <br />
                                    </ul>
                                    <button type="button" className="w-100 btn btn-lg btn-outline-primary"
                                        // onClick={() => AddToCart("Starter", 0.24, 150000, "150k audios included")}
                                        onClick={() => navigate("/AboutUs")}
                                    >Get Started</button>
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="card mb-4 rounded-3 shadow-sm">
                                <div className="card-header py-3">
                                    <h4 className="my-0 fw-normal">Basic</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">₹0.20<small className="text-body-secondary fw-light">/audio</small></h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>200k audios included</li>
                                        <li>Only successfull transcriptions</li>
                                        <li>Max 15 sec per audio clip</li>
                                        <li>TAT - Instant (&lt; 5 seconds)</li>
                                        <li>Email support</li>
                                        <li className="text-success"> <strong>3 days money back guarantee</strong></li>
                                        <br />
                                    </ul>
                                    <button type="button" className="w-100 btn btn-lg btn-outline-primary"
                                        // onClick={() => AddToCart("Basic", 0.20, 200000, "200k audios included")}
                                        onClick={() => navigate("/AboutUs")}
                                    >Get Started</button>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card mb-4 rounded-3 shadow-sm border-primary">
                                <div className="card-header py-3 text-bg-primary border-primary">
                                    <h4 className="my-0 fw-normal">Pro</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">₹0.16<small className="text-body-secondary fw-light">/audio</small></h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>300k audios included</li>
                                        <li>Only successfull transcriptions</li>
                                        <li>Max 15 sec per audio clip</li>
                                        <li>TAT - Instant (&lt; 5 seconds)</li>
                                        <li>Email support</li>
                                        <br />
                                    </ul>
                                    <button type="button" className="w-100 btn btn-lg btn-outline-primary"
                                        // onClick={() => AddToCart("Pro", 0.16, 300000, "300k audios included")}
                                        onClick={() => navigate("/AboutUs")}
                                    >Get Started</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-md-3 mb-3 text-center justify-content-center">

                        <div className="col align-self-center">
                            <div className="card mb-4 rounded-3 shadow-sm border-primary">
                                <div className="card-header py-3 text-bg-primary border-primary">
                                    <h4 className="my-0 fw-normal">Ultimate</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">₹0.12<small className="text-body-secondary fw-light">/audio</small></h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>500k audios included</li>
                                        <li>Only successfull transcriptions</li>
                                        <li>Max 15 sec per audio clip</li>
                                        <li>TAT - Instant (&lt; 5 seconds)</li>
                                        <li>Email support</li>
                                        <br />
                                    </ul>
                                    <button type="button" className="w-100 btn btn-lg btn-primary"
                                        // onClick={() => AddToCart("Ultimate", 0.12, 500000, "500k audios included")}
                                        onClick={() => navigate("/AboutUs")}
                                    >Get Started</button>
                                </div>
                            </div>
                        </div>

                        <div className="col align-self-center">
                            <div className="card mb-4 rounded-3 shadow-sm border-primary">
                                <div className="card-header py-3 text-bg-primary border-primary">
                                    <h4 className="my-0 fw-normal">Enterprise</h4>
                                </div>
                                <div className="card-body">
                                    <h1 className="card-title pricing-card-title">₹5<small className="text-body-secondary fw-light">/minute</small></h1>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li>Pay as you go</li>
                                        <li>Minimum 5 min per audio clip</li>
                                        <li>Max 15 min audio clip</li>
                                        <li>Quick transcriptions</li>
                                        <li>Email support</li>
                                        <br />
                                    </ul>
                                    <button type="button" className="w-100 btn btn-lg btn-primary" onClick={() => navigate("/AboutUs")} >Contact Us</button>
                                </div>
                            </div>
                        </div>
                    </div>



                    <h2 className="display-6 text-center mb-4" id="features">Compare plans</h2>

                    <div className="table-responsive">
                        <table className="table text-center">
                            <thead>
                                <tr>
                                    <th style={{ "width": " 34%" }}></th>
                                    <th style={{ "width": "22%" }}>Starter</th>
                                    <th style={{ "width": "22%" }}>Basic</th>
                                    <th style={{ "width": "22%" }}>Pro</th>
                                    <th style={{ "width": "22%" }}>Ultimate</th>
                                    <th style={{ "width": "22%" }}>Enterprise</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row" className="text-start">Number of Audios</th>
                                    <td>1,50,000</td>
                                    <td>2,00,000</td>
                                    <td>3,00,000</td>
                                    <td>5,00,000</td>
                                    <td>Pay as you go</td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <th scope="row" className="text-start">Audio Length</th>
                                    <td colSpan={4}>15 seconds</td>
                                    <td colSpan={4}>Min 5 min, Max 15 min</td>
                                </tr>
                                <tr>
                                    <th scope="row" className="text-start">Success-based billing</th>
                                    <td colSpan={4}>Yes</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th scope="row" className="text-start">Support Type</th>
                                    <td colSpan={5}>Email </td>
                                </tr>
                                <tr>
                                    <th scope="row" className="text-start">TAT</th>
                                    <td colSpan={4}> Instant (&lt;5 seconds) </td>
                                    <td>Quick</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </main>

                <Footer />
            </div>
        </>

    );
}




function ShowContactUsModal() {
    // // Show the contact us modal
    // const modal = document.getElementById("contactUsModal");
    // modal.style.display = "block";

    // // Close the modal when the user clicks outside of it
    // window.onclick = function (event) {
    //     if (event.target == modal) {
    //         modal.style.display = "none";
    //     }
    // }
}

export default Pricing;